import React from 'react';
import PropTypes from 'prop-types';
import { times } from 'ramda';

import { Container, Line } from './hamburger.styles';

export const Hamburger = ({ onClick }) => (
  <Container onClick={onClick}>
    {times(
      key => (
        <Line key={key} />
      ),
      4
    )}
  </Container>
);

Hamburger.propTypes = {
  onClick: PropTypes.func.isRequired,
};
